import React from 'react';
import { createBrowserHistory } from 'history';
import { Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { Provider as StoreProvider } from 'react-redux';
import store from 'src/store';
import MarketplaceForm from 'src/components/MarketplaceForm';
import MainLayout from 'src/layout';
import { ThemeProvider } from '@material-ui/styles';
import theme from 'src/theme';
import { CssBaseline } from '@material-ui/core';
import 'src/assets/scss/main.scss';
import { TelemetryProvider } from 'src/utils/appInsights';
import AuthProvider from 'src/auth/AuthProvider';
import SnackbarProvider from 'src/components/Snackbar';

const history = createBrowserHistory();

const App = () => {
    return (
        <StoreProvider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <SnackbarProvider>
                    <Router history={history}>
                        <QueryParamProvider ReactRouterRoute={Route}>
                            <TelemetryProvider>
                                <AuthProvider>
                                    <MainLayout>
                                        <MarketplaceForm />
                                    </MainLayout>
                                </AuthProvider>
                            </TelemetryProvider>
                        </QueryParamProvider>
                    </Router>
                </SnackbarProvider>
            </ThemeProvider>
        </StoreProvider>
    );
};

export default App;